import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class LabelaryService {
  private labelaryUrl = 'http://api.labelary.com/v1/printers/8dpmm/labels';

  constructor(private http: HttpClient) {}

  convertZplToPng(
    zplCode: string,
    labelSize: string,
    density: string = '4dpmm'
  ): Observable<Uint8Array | null> {
    const finalLabelSize = labelSize ?? '4x6';
    const url = `${this.labelaryUrl}${density}/${finalLabelSize}/0/`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const data = new URLSearchParams();
    data.set('zpl', zplCode);

    return this.http
      .post(url, data.toString(), {
        headers,
        responseType: 'arraybuffer',
        observe: 'response',
      })
      .pipe(
        map((response) => {
          if (response.status === 200) {
            return new Uint8Array(response.body as ArrayBuffer);
          }
          console.error(
            `Labelary request failed with status ${response.status}`
          );
          return null;
        }),
        catchError((error) => {
          console.error(`Error sending ZPL code to Labelary: ${error.message}`);
          return of(null);
        })
      );
  }

  convertZplToPng1(zplCode: string | string[], lblsize: string): string {
    lblsize = (lblsize || '').toLowerCase();
      if (!lblsize || lblsize.startsWith('x')) {
      lblsize = '2x3';
    }

    let zpl: string = Array.isArray(zplCode)
      ? zplCode.join('\n')
      : zplCode || '';

    zpl = zpl.replace(/[\u200B-\u200D\uFEFF]/g, '');
    const zplHasCommands = /\^XA|\^XZ|\^FT|\^FD|\^LL|\^PW|\^BY|\^CI/.test(zpl);

    if (!zplHasCommands) {
      return '';
    }
    const url = `${this.labelaryUrl}/${lblsize}/0/${zplCode}`;
    return url;
  }
}
